<div class="layout-container d-flex">
    <app-sidebar />
    <main class="layout-content d-flex flex-column">
        <app-top-bar />
        <router-outlet></router-outlet>
    </main>
</div>
